import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import CardName from "../../../components/global/CardName";
import CardDescription from "../../../components/card/CardDescription";
import ErrorAdd from "../../../util/ErrorAdd";

function UserModalEdit({ show, onHide, model }) {

  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState(null);

  const [formName, setFormName] = useState(null);
  const [formRole, setFormRole] = useState(0);
  const [formDescription, setFormDescription] = useState(null);

  const [hideName, setHideName] = useState(false);
  const [hideDescription, setHideDescription] = useState(false);
  const [logName, setLogName] = useState(null);
  const [loadingName, setLoadingName] = useState(false);

  useEffect(() => {
    if (show === true) {
      setLog(null);
      setLoading(false);
      setFormName(model.Name_User);
      setFormRole(model.ID_Role);
      //setFormDescription(model.User_Description);
    }
  }, [show]);


  function updateHandler() {
    setLoading(true);
    setLog(null);

    if (formName === '' || formName === ' ' || formName === null || formName === undefined) {
      setLog('Введите имя пользователя');

    }
    else if (formRole === null || formRole === undefined) {
      setLog('Выберите роль');
    }
    else {
      axios.post('/api_main/company/userServiceUpdate', { ID_Service: process.env.REACT_APP_ID_SERVICE, ID_User: model.ID_User, ID_Role: formRole, User_Name: formName, User_Description: null })
        .then((res) => {
          if (res.data.Status === 1) {
            onHide();
          }
          else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLog('Неизвестная ошибка!');
          setLoading(false);
          ErrorAdd(err, window.location.href);
        });
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Body>
          <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>

          <CardName name={formName} onlyRead={false} placeholder='Название параметра...' updateHandler={setFormName} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
          {
            /*
                      <CardDescription text={model.Description} rows={5} placeholder="описание..." updateHandler={setFormDescription} /*loading={loadingDescription}*/ /*log={logDescription}*/ /*hide = { hideDescription } setHide={setHideDescription} />

*/
          }


          <label className="form-label mt-3">Роль в компании</label>
          <div className="row mb-3 ">
            {formRole === 0 ? (
              <div className="col-md-6 mb-10">
                <button className='param_button active'>
                  Владелец
                </button>
              </div>
            ) : (
              <>
                <div className="col-md-6 mb-10">
                  <button className={'param_button' + (formRole === 2 ? ' active' : '')} onClick={() => setFormRole(2)} >
                    Пользователь
                  </button>
                </div>
                <div className="col-md-6 mb-10">
                  <button className={'param_button' + (formRole === 1 ? ' active' : '')} onClick={() => setFormRole(1)} >
                    Администратор
                  </button>
                </div>
              </>
            )
            }

          </div>


          {log !== null && <div className="form_error text-center mt-15">{log}</div>}

          <div className="row mt-15">
            <div className="col-md-12 text-center">
              <SrvButton typeBtn="save" onClick={() => updateHandler()} loading={loading} size={'lg'} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default UserModalEdit;
